import React from "react";
import { OverlayTrigger, Icon } from "components/common";
const NotificationHelp = ({ message }) => /* @__PURE__ */ React.createElement(OverlayTrigger, { placement: "top", overlay: message, trigger: ["hover", "click"], rootClose: true }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Icon, { name: "help" })));
export default NotificationHelp;
